class ChangeImageVariantAB {
  constructor({
    mainSelector = '[data-product-photos]',
    slideSelector = '.product-main-slide',
    thumbsSelector = '[data-product-thumbs]',
    thumbItemSelector = '.product__thumb-item'
  } = {}) {
    this.main = document.querySelector(mainSelector);
    if (!this.main) return;

    this.slideSelector = slideSelector;
    this.thumbsWrap = document.querySelector(thumbsSelector);
    this.thumbItemSelector = thumbItemSelector;

    // Store initial HTML structure for slides and thumbnails
    this.allSlidesHTML = Array.from(this.main.querySelectorAll(slideSelector)).map(s => s.outerHTML);
    this.allThumbsHTML = this.thumbsWrap
      ? Array.from(this.thumbsWrap.querySelectorAll(thumbItemSelector)).map(t => t.outerHTML)
      : [];

    this.rebuildSlider(); 
    this.installListeners();
  }

  // Gets the currently selected color swatch value from the DOM
  getSelectedColorFromDOM() {
    const checked = document.querySelector('input[type=radio].variant__input--color-swatch:checked');
    return checked ? checked.value.toLowerCase().trim() : '';
  }

  // Initializes listeners for variant changes and applies initial color
  installListeners() {
    const color = this.getSelectedColorFromDOM();
    if (color) {
      this.applyColor(color);
    }

    document.addEventListener('variant:change', (e) => {

      if (e.detail.originalEvent.target.name === 'Color') {

        const color = (e.detail.originalEvent.target.value || '').toLowerCase().trim();
        if (!color) return;
        this.applyColor(color);
      }
    });
  }

  // Filters images by color keyword and remounts the slider with matching items
  applyColor(color) {
    const pat = new RegExp(`\\\\\\s*${color.replace(/[.*+?^${}()|[\]\\]/g,'\\$&')}\\s*\\\\`, 'i');

    const filteredSlides = this.allSlidesHTML.filter(html => pat.test(html));
    const finalSlides = filteredSlides.length ? filteredSlides : this.allSlidesHTML;

    const filteredThumbs = this.allThumbsHTML.filter(html => pat.test(html));
    const finalThumbs = (filteredThumbs.length ? filteredThumbs : this.allThumbsHTML);

    this.mount(finalSlides, finalThumbs);
  }

  // Main function to rebuild and reinitialize Flickity and Photoswipe galleries
  mount(slidesHTML, thumbsHTML) {
    const existingF = window.Flickity ? Flickity.data(this.main) : null;
    if (existingF) { existingF.destroy(); }
    this.main.innerHTML = slidesHTML.join('');

    // Reassign indexes and accessibility attributes to slides
    const slides = Array.from(this.main.querySelectorAll(this.slideSelector));
    slides.forEach((slide, i) => {
      slide.setAttribute('data-index', i);
      slide.setAttribute('tabindex', i === 0 ? '0' : '-1');
      slide.classList.toggle('starting-slide', i === 0);
      slide.classList.remove('is-selected'); 
    });

    // Rebuild thumbnails if container exists
    if (this.thumbsWrap && thumbsHTML.length) {
      this.thumbsWrap.innerHTML = `
        <div class="product__thumbs--scroller">
          ${thumbsHTML.join('')}
        </div>
      `;
      const thumbItems = Array.from(this.thumbsWrap.querySelectorAll(this.thumbItemSelector));
      thumbItems.forEach((t, i) => {
        t.setAttribute('data-index', i);
        const a = t.querySelector('[data-product-thumb]');
        if (a) {
          a.classList.toggle('is-active', i === 0);
          a.setAttribute('data-index', i);
        }
      });

      // Sync thumb click with Flickity slide selection
      this.thumbsWrap.addEventListener('click', (evt) => {
        const item = evt.target.closest(this.thumbItemSelector);
        if (!item) return;
        const idx = parseInt(item.getAttribute('data-index'), 10);
        if (!Number.isNaN(idx) && this.flickity) {
          this.flickity.select(idx, false, true);
          this.thumbsWrap.querySelectorAll('[data-product-thumb]').forEach(a => a.classList.remove('is-active'));
          const a = item.querySelector('[data-product-thumb]');
          if (a) a.classList.add('is-active');
          evt.preventDefault();
        }
      }); 
    }

    // Initialize Flickity main gallery
    this.flickity = new Flickity(this.main, {
      cellSelector: this.slideSelector,
      wrapAround: true,
      pageDots: true,
      prevNextButtons: true,
      adaptiveHeight: true,
      contain: true,
      cellAlign: 'center',
      dragThreshold: 3
    });

    // Sync active thumb with slide change
    if (this.thumbsWrap) {
      this.flickity.on('change', (index) => {
        this.thumbsWrap.querySelectorAll('[data-product-thumb]').forEach(a => a.classList.remove('is-active'));
        const active = this.thumbsWrap.querySelector(`${this.thumbItemSelector}[data-index="${index}"] [data-product-thumb]`);
        if (active) active.classList.add('is-active');
        slides.forEach((s, i) => s.setAttribute('tabindex', i === index ? '0' : '-1'));
      });
    }

    // Reinitialize Photoswipe zoom functionality
    try {
      const imageContainer = this.main.closest('[data-product-images]');
      if (imageContainer && theme?.Photoswipe) {
        new theme.Photoswipe(imageContainer, imageContainer.dataset.sectionId || '');
      }
    } catch (err) {
      console.warn('Error reinstating Photoswipe:', err);
    }

    // Handle zoom click logic on desktop viewports
    if (window.matchMedia('(min-width: 768px)').matches) {
      const zoomButtons = this.main.querySelectorAll('.product-main-slide');
      let isZooming = false;

      zoomButtons.forEach((containerImage) => {
        containerImage.classList.remove('is-selected');
        const btn = containerImage.querySelector('.image-wrap');

        if (!btn) return; 

        btn.addEventListener('click', function (evt) {
          if (isZooming) return;
          isZooming = true;

          const clickElementParent = evt.target.closest('.product-main-slide');
          if (clickElementParent) {
            zoomButtons.forEach((s) => s.classList.remove('is-selected'));
            clickElementParent.classList.add('is-selected');

            setTimeout(() => {
              const zoomBtn = clickElementParent.querySelector('.js-photoswipe__zoom');
              if (zoomBtn) zoomBtn.click();
              setTimeout(() => (isZooming = false), 400);
            }, 100);
          }
        });
      });
    }

  }

  // Rebuilds the entire slider using stored HTML
  rebuildSlider() {
    this.mount(this.allSlidesHTML, this.allThumbsHTML);
  }
}

document.addEventListener('DOMContentLoaded', () => {
  new ChangeImageVariantAB();
});
